import React from 'react';
import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { EditOutlined, MoreOutlined } from '@ant-design/icons';

type ManageTaskListItemProps = {
  task: any;
  onEdit: (task: any) => void;
  onDelete: (taskLogId: number) => void;
};

const ManageTaskListItem: React.FC<ManageTaskListItemProps> = ({ task, onEdit, onDelete }) => {
  const idText = `ID ${task.task_id ?? ''}`.trim();
  const projectTitle =
    task.title && String(task.title).trim()
      ? String(task.title).charAt(0).toUpperCase() + String(task.title).slice(1)
      : '';

  const hasComments = !!(task.comments && String(task.comments).trim());
  // 卡片中间展示：优先 comments，否则展示 title
  const mainText = hasComments ? String(task.comments) : projectTitle || '—';

  const menuItems: MenuProps['items'] = [
    {
      key: 'edit',
      label: 'Manage project',
      icon: <EditOutlined />,
      onClick: () => onEdit(task),
    },
  ];

  return (
    <div
      key={task.task_log_id}
      className="manageTaskListCard"
      style={{
        marginBottom: 16,
        width: '100%',
        borderRadius: 24,
        background: 'linear-gradient(180deg, #FFFFFC 0%, #FBFBF7 100%)',
        boxShadow: '0 2px 20px 0 rgba(0, 0, 0, 0.06)',
        padding: '18px 22px 20px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            padding: '6px 12px',
            borderRadius: 999,
            border: '1px solid #E1E1E1',
            background: '#FBFBF7',
            color: '#0E1F27',
            fontSize: 13,
            fontWeight: 600,
            lineHeight: 1,
            whiteSpace: 'nowrap',
          }}
        >
          {idText}
        </span>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
          }}
        >
          <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
            <Button
              type="text"
              size="small"
              icon={<MoreOutlined style={{ fontSize: 18, color: '#8A8A86' }} />}
              style={{ padding: '4px 6px', minWidth: 32 }}
              aria-label="Task actions"
            />
          </Dropdown>
        </div>
      </div>

      <div
        style={{
          fontSize: 16,
          fontWeight: 500,
          color: '#171717',
          lineHeight: 1.45,
          wordBreak: 'break-word',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {mainText}
      </div>
    </div>
  );
};

export default ManageTaskListItem;

